export const DIRECTION = {
	incoming: 'incoming',
	outgoing: 'outgoing',
};
